import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import type { Tool } from "@/types/tool";
import { lazy, Suspense } from "react";

const ToolFinder = lazy(() => import("@/components/ToolFinder"));

interface QuickMatchModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  tools: Tool[];
  onSelectTools: (ids: string[]) => void;
}

const QuickMatchModal = ({ open, onOpenChange, tools, onSelectTools }: QuickMatchModalProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl p-0 gap-0 border-none bg-transparent shadow-none [&>button]:hidden overflow-y-auto max-h-[90vh]">
        <DialogTitle className="sr-only">Quick Match</DialogTitle>
        <Suspense fallback={<div className="py-12 text-center text-muted-foreground text-sm">Loading...</div>}>
          <ToolFinder
            tools={tools}
            onSelectTools={(ids) => {
              onSelectTools(ids);
              onOpenChange(false);
            }}
            isModal
            onClose={() => onOpenChange(false)}
          />
        </Suspense>
      </DialogContent>
    </Dialog>
  );
};

export default QuickMatchModal;
